import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import LoadingIcon from "mdi-react/LoadingIcon";

import PropertyCard from "../../shared/components/property-card/PropertyCard";
import { propertyActions } from "../../redux/actions";
import { Link } from "react-router-dom";
import { SCREEN_PATH, propertyConstants } from "../../constants";

const FavouritesProperty = (props) => {
  const {
    spinnerActions,
    allFavouritesProperty,
    getAllFavouritesProperty,
    filters,
    allAllowedCountries,
    userPropertyTypes,
    allFavouritesPropertyCount,
    getPropertyTypesByUser,
  } = props;

  const [properties, setProperties] = useState([]);
  const [payload, setPayload] = useState({
    ...filters,
    pageSize: 4,
    countryIds:
      filters.countryIds.length > 0
        ? filters.countryIds
        : allAllowedCountries.map((country) => country.id),
    propertyTypeIds:
      filters.propertyTypeIds.length > 0
        ? filters.propertyTypeIds
        : userPropertyTypes.map((pType) => pType.id),
  });

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  useEffect(() => {
    if (allAllowedCountries.length > 0 && userPropertyTypes.length > 0) {
      getAllFavouritesProperty(payload);
    }
    // eslint-disable-next-line
  }, [payload]);

  useEffect(() => {
    setPayload((prev) => ({
      ...filters,
      pageSize: 4,
      countryIds:
        filters.countryIds.length > 0
          ? filters.countryIds
          : allAllowedCountries.map((country) => country.id),
      propertyTypeIds:
        filters.propertyTypeIds.length > 0
          ? filters.propertyTypeIds
          : userPropertyTypes.map((pType) => pType.id),
    }));
    // eslint-disable-next-line
  }, [allAllowedCountries, userPropertyTypes, filters]);

  useEffect(() => {
    if (allFavouritesProperty) {
      setProperties(allFavouritesProperty);
    }
  }, [allFavouritesProperty]);

  return (
    <div className="favourites-property container">
      <div className="d-flex align-items-center gap-2">
        <h2 className="fs-1-75 fw-bold">Your Favourites</h2>
        {spinner(propertyConstants.ALL_FAVOURITES_PROPERTY) > -1 && (
          <div className="spinner-heading">
            <LoadingIcon />
          </div>
        )}
      </div>
      <div className="row mt-4 pt-2">
        {properties.slice(0, 4).map((property) => (
          <React.Fragment key={property?.id}>
            <PropertyCard
              property={property}
              refetch={(isRemoved) => {
                getAllFavouritesProperty(payload);
                if (isRemoved) {
                  getPropertyTypesByUser({
                    countryIds: payload.countryIds,
                  });
                }
              }}
            />
          </React.Fragment>
        ))}
        {properties.length === 0 && (
          <div className="text-center fs-5">
            You haven't added any favourite properties yet!
          </div>
        )}
      </div>
      {allFavouritesPropertyCount > 4 && (
        <div className="view-all-button">
          <Link to={SCREEN_PATH.FAVOURITES}>
            <button>View All</button>
          </Link>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
  allFavouritesProperty: state.propertyReducer.allFavouritesProperty,
  allFavouritesPropertyCount: state.propertyReducer.allFavouritesPropertyCount,
  allAllowedCountries: state.homeReducer.allAllowedCountries,
  userPropertyTypes: state.propertyReducer.userPropertyTypes,
});

const mapDispatchToProps = (dispatch) => ({
  getAllFavouritesProperty: (data) =>
    dispatch(propertyActions.getAllFavouritesProperty(data)),
  getPropertyTypesByUser: (data) =>
    dispatch(propertyActions.getPropertyTypesByUser(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FavouritesProperty);
